import useTasks from '@modules/TasksModule/hooks/useTasks';
import { TaskState } from '@modules/TasksModule/types';
import { useMemo } from 'react';

const useFurthestTask = () => {
  const { tasks } = useTasks();

  const furthestWrapUpTask = useMemo(() => {
    const tasksInWrapUp = tasks.filter(
      (task) => task.state === TaskState.WrapUp && !!task.wrapUpEndsAt,
    );
    if (tasksInWrapUp.length === 0) {
      return null;
    } else if (tasksInWrapUp.length === 1) {
      return tasksInWrapUp[0];
    } else {
      return tasksInWrapUp.slice(1).reduce((acc, task) => {
        if (task.wrapUpEndsAt! < acc.wrapUpEndsAt!) {
          return acc;
        }
        return task;
      }, tasksInWrapUp[0]);
    }
  }, [tasks]);

  return { furthestWrapUpTask };
};

export default useFurthestTask;
